export default __webpack_public_path__ + "d93c864469f0fb9b7bea9dd71bb1dbb8.svg";